<template>
  <div class="">
    <!-- 查询表单 -->
    <div style="margin-bottom: 10px">
      <el-row style="margin-top: 10px">
        <el-col :span="6">订单编码：{{ orderItemDetailData.orderCode }}</el-col>
        <el-col :span="6"
          >回收商：{{ orderItemDetailData.recyclerName }}</el-col
        >
        <el-col :span="6"
          >状态：
            <span v-if="orderItemDetailData.status === 0">待发货</span>
            <span v-else-if="orderItemDetailData.status === 1">待收货</span>
            <span v-else-if="orderItemDetailData.status === 2">待质检</span>
            <span v-else-if="orderItemDetailData.status === 3">交易中</span>
            <span v-else-if="orderItemDetailData.status === 4">已完成</span>
            <span v-else-if="orderItemDetailData.status === 5">待议价</span>
            <span v-else-if="orderItemDetailData.status === 6">已取消</span>
            <span v-else-if="orderItemDetailData.status === 7">交易关闭中</span>
            <span v-else-if="orderItemDetailData.status === 8">交易已关闭</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="6">下单时间：{{ orderItemDetailData.orderTime }}</el-col>
        <el-col :span="6">下单数量：{{ orderItemDetailData.orderNum }}</el-col>
        <el-col :span="6"
          >下单金额：{{ orderItemDetailData.orderAmount }}</el-col
        >
        <el-col :span="6"
          >下单方式：
          <span v-if="orderItemDetailData.orderType === 0">批量下单</span>
          <span v-else-if="orderItemDetailData.orderType === 1">精准下单</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="6">发货时间：{{ orderItemDetailData.orderTime }}</el-col>
        <el-col :span="6"
          >发货方式：
          <span v-if="orderItemDetailData.mailingType === 0">自行邮寄</span>
          <span v-else-if="orderItemDetailData.mailingType === 2"
            >送货上门</span
          >
        </el-col>
        <el-col :span="6"
          >快递单号：{{ orderItemDetailData.mailingCode }}</el-col
        >
      </el-row>
      <el-row style="margin-top: 10px" v-if="orderItemDetailData.receiveTime!=null">
        <el-col :span="6"
          >收货时间：{{ orderItemDetailData.receiveTime }}</el-col
        >
        <el-col :span="6"
          >收货数量：{{ orderItemDetailData.receiveNum }}</el-col
        >
        <el-col :span="6"
          >收货人：{{ orderItemDetailData.receiverName }}({{orderItemDetailData.receiverPhone}})</el-col
        >
      </el-row>
      <el-row style="margin-top: 10px" v-if="orderItemDetailData.qualityTime!=null">
        <el-col :span="6"
          >质检时间：{{ orderItemDetailData.qualityTime }}</el-col
        >
        <el-col :span="6"
          >质检金额：{{ orderItemDetailData.qualityAmount }}</el-col
        >
        <el-col :span="6"
          >质检人：{{ orderItemDetailData.qualityerName }}({{orderItemDetailData.qualityerPhone}})</el-col
        >
      </el-row>
      <el-row style="margin-top: 10px" v-if="orderItemDetailData.bargainingTime!=null">
        <el-col :span="24">议价时间：{{ orderItemDetailData.bargainingTime }}</el-col
        >
      </el-row>
      <el-row style="margin-top: 10px" v-if="orderItemDetailData.finishTime!=null">
        <el-col :span="24">完成时间：{{ orderItemDetailData.finishTime }}</el-col
        >
      </el-row>
    </div>
    <div>
      <el-form
        ref="queryParamForm"
        :model="queryParamForm"
        label-width="auto"
        label-position="left"
      >
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="物品编号">
              <el-input clearable v-model="queryParamForm.itemCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="IMEI号">
              <el-input clearable v-model="queryParamForm.imei"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="状态">
              <el-select
                clearable
                v-model="queryParamForm.status"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in statusOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="分类">
              <el-select
                clearable
                v-model="queryParamForm.categoryId"
                placeholder="请选择"
                @change="changeOtherOptions()"
              >
                <el-option
                  v-for="item in queryCategoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="品牌">
              <el-select
                clearable
                v-model="queryParamForm.brandId"
                placeholder="请选择"
                @change="getModelList()"
              >
                <el-option
                  v-for="item in queryBrandOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="机型">
              <el-select
                clearable
                v-model="queryParamForm.modelId"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="item in queryModelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-button type="primary" @click="getServiceProviderListSearch"
              >查询</el-button
            >
            <el-button type="primary" @click="batchChafferChat()" v-if="orderItemDetailData.status==5">批量议价</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px">
      <!-- 表格 -->
      <el-table
        :data="orderItemDetailData.orderItemList"
        border
        style="width: 100%"
      >
        <el-table-column prop="itemCode" label="物品编码"> </el-table-column>
        <el-table-column prop="categoryName" label="分类">
          <template slot-scope="scope">
            {{ scope.row.categoryName || "待验机" }}
          </template>
        </el-table-column>
        <el-table-column prop="brandName" label="品牌">
          <template slot-scope="scope">
            {{ scope.row.brandName || "待验机" }}
          </template>
        </el-table-column>
        <el-table-column prop="modelName" label="机型">
          <template slot-scope="scope">
            {{ scope.row.modelName || "待验机" }}
          </template>
        </el-table-column>
        <el-table-column prop="gradeName" label="等级"> </el-table-column>
        <el-table-column prop="recoveryAmount" label="回收价">
          <template slot-scope="scope">
            {{ scope.row.recoveryAmount > 0 ? scope.row.recoveryAmount : "" }}
          </template>
        </el-table-column>
        <el-table-column prop="chafferType" label="议价方式">
          <template slot-scope="scope">
            <span v-if="scope.row.chafferType === 0">整单</span>
            <span v-else-if="scope.row.chafferType === 1">批量</span>
            <span v-else-if="scope.row.chafferType === 2">单台</span>
          </template>
        </el-table-column>
        <el-table-column prop="markUpAmount" label="加价金额">
           <template slot-scope="scope">
               {{scope.row.markUpAmount>0?scope.row.markUpAmount:''}}
          </template>
        </el-table-column>
        <el-table-column prop="chaffererName" label="议价人"> </el-table-column>
        <el-table-column prop="recyclerName" label="回收商"> </el-table-column>
        <el-table-column prop="updateTime" label="更新时间"> </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0">待质检</span>
            <span v-else-if="scope.row.status === 1">待确认</span>
            <span v-else-if="scope.row.status === 2">待结算</span>
            <span v-else-if="scope.row.status === 3">已结算</span>
            <span v-else-if="scope.row.status === 4">待议价</span>
            <span v-else-if="scope.row.status === 5">待退货</span>
            <span v-else-if="scope.row.status === 6">退货中</span>
            <span v-else-if="scope.row.status === 7">已退货</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button @click="detail(scope.row)" type="text" size="small"
              >查看</el-button
            >
            <el-button
              @click="chafferChat(scope.row)"
              type="text"
              size="small"
              v-if="scope.row.status === 4"
              >议价沟通</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 修改或新建对话框 -->
    <el-dialog title="议价沟通" :visible.sync="isDlg" width="700px" append-to-body>
      <div style="margin: 20px">
        <div>
          <el-form
            ref="chafferForm"
            :model="chafferForm"
            :rules="editorFormRules"
            label-width="130px"
          >
            <el-row>
              <el-col :span="12"
                ><el-form-item label="收货台数">
                  {{ chafferForm.receiveNum }}台
                </el-form-item></el-col
              >
              <el-col :span="12"
                ><el-form-item label="待议价台数">
                  {{ chafferForm.chafferNum }}台
                </el-form-item></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="12"
                ><el-form-item label="总回收价">
                  {{ chafferForm.receiveAmount }}元
                </el-form-item></el-col
              >
              <el-col :span="12"
                ><el-form-item label="待议价金额">
                  {{ chafferForm.chafferAmount }}元
                </el-form-item></el-col
              >
            </el-row>
            <el-form-item label="加价金额" prop="markUpAmount">
              <el-row>
                <el-col :span="12">
                  <el-input
                    clearable
                    v-model="chafferForm.markUpAmount"
                    @input="calcAmount($event)"
                  ></el-input
                ></el-col>
                <el-col :span="12">元</el-col>
              </el-row>
            </el-form-item>
            <el-row>
              <el-col :span="12"
                ><el-form-item label="议价后总回收价">
                  {{ chafferForm.chafferBeforeAmount }}元
                </el-form-item></el-col
              >
              <el-col :span="12"
                ><el-form-item label="议价机器总回收价">
                  {{ chafferForm.totalReceiveAmount }}元
                </el-form-item></el-col
              >
            </el-row>
          </el-form>
        </div>
        <div style="text-align: center">
          <el-button
            type="primary"
            style="margin: 30px 20px"
            @click="submitEditor"
            >确认加价</el-button
          >
          <el-button style="margin: 10px 20px" @click="chafferFail"
            >议价失败转退货</el-button
          >
          <el-button style="margin: 10px 20px" @click="closeEditormodelDlg"
            >取消</el-button
          >
        </div>
      </div>
    </el-dialog>

     <!-- 议价失败提示对话框 -->
    <el-dialog title="议价失败" :visible.sync="chafferFailDlg" width="400px" append-to-body>
      <div style="margin: 20px">
        <div>
          <div>
            <div style="margin-bottom: 10px">
              议价失败原因
            </div>
             <el-checkbox-group v-model="chafferRemark">
             <el-checkbox label="质检不满意"></el-checkbox>
             <el-checkbox label="价格不满意"></el-checkbox>
              </el-checkbox-group>
          </div>
        </div>
        <div style="text-align: center">
          <el-button
            type="primary"
            style="margin: 30px 20px"
            @click="confirmReturnGoods"
            >确认退货</el-button
          >
          <el-button style="margin: 10px 20px" @click="closeEditormodelDlg"
            >取消</el-button
          >
        </div>
      </div>
    </el-dialog>

     <!-- 议价失败提示对话框 -->
    <el-dialog title="物品详情" :visible.sync="queryItemDlg" width="1000px" append-to-body>
      <div style="margin: 20px">
        <div>
          <item-detail ref="itemDetail"></item-detail>
        </div>
        <div style="text-align: right">
          <el-button style="margin: 10px 20px" @click="closeQueryItemDlg"
            >取消</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ItemDetail from "./itemDetail.vue";
export default {
  name: "orderItemDetail",
  components: {ItemDetail},
  data() {
    return {
      queryItemDlg: false,
      itemCode: null,
      chafferFailDlg: false,
      chafferRemark:[],
      // 查询数据
      queryParamForm: {
        brandId: null,
        modelId: null,
        categoryId: null,
        status: null,
        imei: null,
        itemCode: null,
        orderCode: null,
      },
      // 订单状态选择框
      statusOptions: [
        {
          id: 0,
          name: "待质检",
        },
        {
          id: 1,
          name: "待确认",
        },
        {
          id: 2,
          name: "待结算",
        },
        {
          id: 3,
          name: "已结算",
        },
        {
          id: 4,
          name: "待议价",
        },
        {
          id: 5,
          name: "待退货",
        },
        {
          id: 6,
          name: "退货中",
        },
        {
          id: 7,
          name: "已退货",
        },
      ],
      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      queryModelList: [],

      queryBrandOptions: [],

      queryCategoryOptions: [],

      // 新建编辑对话框数据
      userInfo: {},

      isDlg: false,
      chafferForm: {
        receiveNum: 0,
        chafferNum: 0,
        receiveAmount: 0,
        chafferAmount: 0,
        markUpAmount: null,
        chafferBeforeAmount: 0,
        totalReceiveAmount: 0,
        chafferType:0
      },

      editorFormRules: {
        name: [
          { required: true, message: "请输入回收商名称", trigger: "change" },
        ],
        contactPerson: [
          { required: true, message: "请输入联系人", trigger: "change" },
        ],
        contactNumber: [
          { required: true, message: "请输入联系电话", trigger: "change" },
        ],
      },

      dlgType: "change",

      orderItemDetailData: {},

      itemCodes:[],

      // 选择
      loading: false,
    };
  },

  computed: {},
  methods: {
    init (orderCode) {
      this.queryParamForm.orderCode = orderCode
      this.orderItemDetailData={}
      this.getConsignmentOrderInfo(orderCode);
    },
    closeQueryItemDlg(){
       this.queryItemDlg = false
    },
    chafferFail(){
      this.isDlg = false;
      this.chafferFailDlg = true
    },
    confirmReturnGoods() {
      let self = this;
      let params = {};
      params.itemCodes = self.itemCodes;
      params.mailingName = null;
      params.returnMailing = null;
      params.returnGoodsNum = this.chafferForm.chafferNum;
      params.returnGoodsAmount = this.chafferForm.receiveAmount;
      if(this.chafferFailDlg){
        params.returnType = 1;
        params.remark = this.chafferRemark.join(",");
        params.chafferType=  this.chafferForm.chafferType
      }
      self.$api.confirmReturnGoods(params).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "退货操作成功",
            type: "success",
          });
          this.getConsignmentOrderInfo(this.queryParamForm.orderCode);
          self.closeEditormodelDlg();
        }
      });
    },
    calcAmount(e){
      this.chafferForm.chafferBeforeAmount = this.chafferForm.receiveAmount+Number(e);
      this.chafferForm.totalReceiveAmount = this.chafferForm.receiveAmount+Number(e);
    },
    getCategroyOptions() {
      let self = this;
      this.$api
        .getTemplateValue({
          typeKey: "category",
        })
        .then((res) => {
          self.queryCategoryOptions = res.data || [];
        });
    },
    //改变分类，品牌和等级集合发生变化
    changeOtherOptions() {
      let self = this;
      self.$set(self.queryParamForm, "brandId", null);
      self.$set(self.queryParamForm, "modelId", null);
      self.$set(self, "queryModelList", []);
      self.getBrandOptions();
    },
    getBrandOptions() {
      let categoryId = this.queryParamForm.categoryId;
      if (categoryId === "") {
        this.$set(this, "queryBrandOptions", []);
      } else {
        let self = this;
        self.$api
          .getClass({
            categoryId: categoryId,
            typeKey: "phoneBrand",
            status: 1,
            page: 1,
            size: 100000,
          })
          .then((res) => {
            self.queryBrandOptions = res.data.records || [];
          });
      }
    },
    getModelList() {
      let brandId = this.queryParamForm.brandId;
      this.$set(this.queryParamForm, "modelId", null);
      if (brandId === "") {
        this.$set(this, "queryModelList", []);
      } else {
        let self = this;
        self.$api
          .getClass({
            brandId: brandId,
            typeKey: "phoneModal",
            status: 1,
            page: 1,
            size: 100000,
          })
          .then((res) => {
            self.queryModelList = res.data.records || [];
          });
      }
    },
    deleteServiceProvider(id) {
      let self = this;
      self.$confirm("是否删除").then(() => {
        self.$api.deleteServiceProvider({ id: id }).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getServiceProviderListSearch();
          }
        });
      });
    },
    // 分页函数
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      // 重新请求表格数据
      this.getServiceProviderListSearch();
    },

    // 获取表格数据
    getServiceProviderListSearch() {
      let self = this;
      self.$api
        .getItemListByOrderCode({
          orderCode: self.queryParamForm.orderCode,
          itemCode: self.queryParamForm.itemCode || null,
          status: self.queryParamForm.status || null,
          imei: self.queryParamForm.imei || null,
          categoryId: self.queryParamForm.categoryId || null,
          brandId: self.queryParamForm.brandId || null,
          modelId: self.queryParamForm.modelId || null,
        })
        .then((res) => {
          self.orderItemDetailData.orderItemList = res.data || [];
        });
    },

    // 修改
    chafferChat(row) {
      let self = this;
      self.itemCodes=[]
      this.chafferForm.chafferType = 2
      this.chafferForm.receiveNum = 1;
      this.chafferForm.chafferNum = 1;
      this.chafferForm.receiveAmount = row.recoveryAmount;
      this.chafferForm.markUpAmount = 0;
      this.chafferForm.chafferAmount = this.chafferForm.receiveAmount;
      this.chafferForm.chafferBeforeAmount = this.chafferForm.receiveAmount;
      this.chafferForm.totalReceiveAmount = this.chafferForm.receiveAmount;
      self.itemCodes.push(row.itemCode)
      self.isDlg = true;
    },

    batchChafferChat() {
      let self = this;
      self.itemCodes=[]
      this.chafferForm.chafferType = 0
      this.chafferForm.receiveNum = self.orderItemDetailData.receiveNum;
      this.chafferForm.chafferNum = self.orderItemDetailData.orderItemList.length;
      this.chafferForm.receiveAmount = 0;
      this.chafferForm.markUpAmount = 0;
      if(self.orderItemDetailData.orderItemList!=null&&self.orderItemDetailData.orderItemList.length>0){
        self.orderItemDetailData.orderItemList.forEach(e => {
          self.chafferForm.receiveAmount =  e.recoveryAmount+self.chafferForm.receiveAmount
          self.itemCodes.push(e.itemCode)
        });
      }
     
      this.chafferForm.chafferAmount = this.chafferForm.receiveAmount;
      this.chafferForm.chafferBeforeAmount = this.chafferForm.receiveAmount;
      this.chafferForm.totalReceiveAmount = this.chafferForm.receiveAmount;
      self.isDlg = true;
    },

    detail(row) {
      let self = this;
      self.itemCode=row.itemCode
      self.queryItemDlg = true
      this.$nextTick(()=>{
        self.$refs.itemDetail.init(self.itemCode)
      })
    },

    // 关闭编辑对话框
    closeEditormodelDlg() {
      this.isDlg = false;
      this.chafferFailDlg = false;
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs["chafferForm"].validate((valid) => {
        if (valid) {
          let params = {};
          params.itemCodes = self.itemCodes
          params.markUpAmount = this.chafferForm.markUpAmount
          params.totalReceiveAmount = this.chafferForm.receiveAmount
          params.chafferNum = this.chafferForm.chafferNum
          params.chafferType =  this.chafferForm.chafferType
          self.$api.getItemChaffer(params).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.getConsignmentOrderInfo(this.queryParamForm.orderCode);
              self.closeEditormodelDlg();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    getConsignmentOrderInfo(orderCode) {
      let self = this;
      this.$api
        .getConsignmentOrderInfo({ orderCode: orderCode })
        .then((res) => {
          self.orderItemDetailData = res.data;
        });
    },
  },
  created() {
  },
  mounted() {
    let self = this;
    self.getCategroyOptions();
  },
};
</script>
<style lang="less" scoped>
</style>
